module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-image', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "radius": "10px",
      "fit": "contain",
      "src": require('@/assets/images/jifen.png')
    }
  }), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "70%",
      "height": "100px",
      "align-content": "center",
      "text-align": "center",
      "font-size": "large"
    },
    attrs: {
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_vm._v("抱歉，你没有权限查看")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "box1"
  }, [_vm._v("全局排名第 " + _vm._s(_vm.mingci))]), _vm._v(" "), _c('div', {
    staticClass: "box2"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "box3"
  }, [_vm._v(_vm._s(_vm.jifen) + " 积分")])]), _vm._v(" "), _c('div', {
    staticClass: "top-wrap"
  }, _vm._l((_vm.datas), function(item, index) {
    return _c('div', {
      key: item.index,
      staticClass: "list-item"
    }, [(index == 0) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [(index <= 2) ? _c('van-image', {
      staticClass: "img-tag",
      attrs: {
        "width": "30",
        "src": _vm.getImg(index)
      }
    }) : _vm._e(), _vm._v(" "), (index > 2) ? _c('span', {
      staticClass: "number"
    }, [_vm._v(_vm._s(index + 1))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "20px",
        "width": "60px"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin-left": "15px",
        "width": "100px"
      }
    }, [_vm._v(_vm._s(_vm.getphone(item.phone)))]), _vm._v(" "), _c('span', {
      staticClass: "time"
    }, [_vm._v(_vm._s(item.point) + " 积分 ")])], 1), _vm._v(" "), _c('div', {
      staticClass: "line"
    })])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6eba3266"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/studyRanking.vue
// module id = 538
// module chunks = 1